// eslint-disable-next-line no-shadow
export enum ButtonTypesEnum {
  Primary = 1,
  Secondary,
  Tertiary,
  Link,
  LinkSecondary,
  Discover,
}
